<template>
  <div>
    <b-modal
      ref="Ref-2fa-Modal"
      title="2FA Authentication"
      id="2fa-Modal"
      :no-enforce-focus="true"
      hide-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      hide-backdrop
      modal-class="twofa-auth-modal"
      content-class="twofa-auth-modal-content"
      body-class="twofa-auth-modal-body"
    >
      <section class="twofa-auth-card">
        <button
          type="button"
          class="twofa-close-btn"
          aria-label="Close"
          @click="ClearData()"
        >
          &times;
        </button>

        <div class="twofa-auth-heading">
          <h4>{{ modalTitle }}</h4>
          <span>{{ modalDescription }}</span>
        </div>

        <form class="twofa-auth-form" @submit.prevent.stop="onConfirm()">
          <label class="twofa-field-label" for="secretcode">{{
            $t("secretcode")
          }}</label>
          <div
            class="twofa-input-shell"
            :class="{ active: showPinPad }"
          >
            <input
              v-model="secretCode"
              name="secretcode"
              id="secretcode"
              ref="secretcode"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="6"
              autocomplete="one-time-code"
              placeholder="Enter 6 digit code"
              @click="openPinPad"
              @focus="openPinPad"
              @input="onSecretInput($event)"
              @keypress="isNumber($event)"
              v-validate="'required|numeric|min:6|max:6'"
            />
          </div>
          <div v-if="showPinPad" class="twofa-pin-pad">
            <button
              v-for="key in pinPadKeys"
              :key="'twofa-pin-key-' + key.value"
              type="button"
              class="twofa-pin-key"
              :class="{ muted: key.type != 'number' }"
              @click.prevent.stop="onPinPadKey(key)"
            >
              {{ key.label }}
            </button>
          </div>
          <p class="error_message twofa-error">
            <span v-if="submitted && errors.has('secretcode')">{{
              errors.first("secretcode")
            }}</span>
          </p>
          <button type="submit" class="twofa-confirm-btn">
            <span>{{ $t("confirm") }}</span>
          </button>
        </form>
      </section>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    openModal: Boolean,
    token: Number,
    onClickHandler: {
      type: Function
    },
    onClose: Boolean,
    onlyAuthenticator: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      secretCode: "",
      submitted: false,
      showPinPad: false,
      pinPadKeys: [
        { label: "1", value: "1", type: "number" },
        { label: "2", value: "2", type: "number" },
        { label: "3", value: "3", type: "number" },
        { label: "4", value: "4", type: "number" },
        { label: "5", value: "5", type: "number" },
        { label: "6", value: "6", type: "number" },
        { label: "7", value: "7", type: "number" },
        { label: "8", value: "8", type: "number" },
        { label: "9", value: "9", type: "number" },
        { label: "C", value: "clear", type: "clear" },
        { label: "0", value: "0", type: "number" },
        { label: "Del", value: "delete", type: "delete" }
      ]
    };
  },
  computed: {
    modalTitle() {
      return this.onlyAuthenticator
        ? "Authenticator Login"
        : "2FA Authentication";
    },
    modalDescription() {
      return this.onlyAuthenticator
        ? "Enter the 6 digit code from your authenticator app to continue."
        : "Confirm this login with the 6 digit code from your authenticator app.";
    }
  },
  watch: {
    openModal(newVal) {
      if (newVal) {
        this.$refs["Ref-2fa-Modal"].show();
      } else {
        this.resetSecretCode();
        this.$refs["Ref-2fa-Modal"].hide();
      }
    }
  },
  methods: {
    ClearData: function() {
      this.resetSecretCode();
      this.$emit("onClose", false);
    },
    isNumber: function(value) {
      if (value.keyCode < 48 || value.keyCode > 57) {
        value.preventDefault();
      }
    },
    openPinPad: function() {
      this.showPinPad = true;
    },
    focusSecretInput: function() {
      this.$nextTick(() => {
        if (this.$refs.secretcode) {
          this.$refs.secretcode.focus();
        }
      });
    },
    onSecretInput: function(event) {
      this.secretCode = this.normalizeSecretCode(event.target.value);
    },
    onPinPadKey: function(key) {
      if (key.value == "clear") {
        this.secretCode = "";
      } else if (key.value == "delete") {
        this.secretCode = this.secretCode.slice(0, -1);
      } else if (this.secretCode.length < 6) {
        this.secretCode = this.normalizeSecretCode(this.secretCode + key.value);
      }
      this.submitted = false;
      this.focusSecretInput();
    },
    normalizeSecretCode: function(value) {
      return String(value || "")
        .replace(/\D/g, "")
        .slice(0, 6);
    },
    resetSecretCode: function() {
      this.secretCode = "";
      this.submitted = false;
      this.showPinPad = false;
    },
    onConfirm: function() {
      this.submitted = true;
      this.secretCode = this.normalizeSecretCode(this.secretCode);
      if (this.secretCode && String(this.secretCode).length == 6) {
        this.showPinPad = false;
        this.$emit("onConfirm", this.secretCode);
      }
    }
  }
};
</script>

<style>
.twofa-auth-modal .modal-dialog {
  max-width: 460px;
}

.twofa-auth-modal-content {
  border: 0;
  border-radius: 28px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.24);
}

.twofa-auth-modal-body {
  padding: 0 !important;
  background:
    radial-gradient(circle at top left, rgba(18, 44, 106, 0.12), transparent 34%),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.twofa-auth-card {
  position: relative;
  padding: 36px;
  text-align: center;
}

.twofa-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  color: #64748b;
  font-size: 24px;
  line-height: 30px;
  background: #f1f5f9;
  cursor: pointer;
}

.twofa-close-btn:hover,
.twofa-close-btn:focus {
  color: #111827;
  background: #e2e8f0;
}

.twofa-auth-heading h3 {
  margin: 0;
  color: #111827;
  font-size: 26px;
  font-weight: 800;
}

.twofa-auth-heading span {
  display: block;
  max-width: 330px;
  margin: 10px auto 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
}

.twofa-auth-form {
  margin-top: 26px;
}

.twofa-field-label {
  display: block;
  margin-bottom: 8px;
  color: #334155;
  font-size: 13px;
  font-weight: 800;
  text-align: left;
}

.twofa-input-shell {
  height: 56px;
  display: flex;
  align-items: center;
  border: 1px solid #dbe3ef;
  border-radius: 16px;
  background: #ffffff;
  transition: border-color 0.14s ease, box-shadow 0.14s ease;
}

.twofa-input-shell.active,
.twofa-input-shell:focus-within {
  border-color: var(--blue);
  box-shadow: 0 0 0 4px rgba(18, 44, 106, 0.08);
}

.twofa-input-shell input {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0 16px;
  border: 0;
  outline: 0;
  color: #111827;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.16em;
  background: transparent;
}

.twofa-input-shell input::placeholder {
  color: #94a3b8;
  font-size: 15px;
  font-weight: 650;
  letter-spacing: 0;
}

.twofa-pin-pad {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.twofa-pin-key {
  height: 45px;
  border: 1px solid #e2e8f0;
  border-radius: 13px;
  color: #0f172a;
  font-size: 17px;
  font-weight: 600;
  background: linear-gradient(180deg, #ffffff, #f8fafc);
  cursor: pointer;
  transition: border-color 0.14s ease, background 0.14s ease, transform 0.14s ease;
}

.twofa-pin-key:hover,
.twofa-pin-key:focus {
  border-color: #bfdbfe;
  color: #1d4ed8;
  background: #ffffff;
}

.twofa-pin-key:active {
  transform: translateY(1px) scale(0.99);
}

.twofa-pin-key.muted {
  color: #64748b;
  font-size: 15px;
  background: #f1f5f9;
}

.twofa-error {
  min-height: 22px;
  margin: 7px 0 4px;
  text-align: left;
}

.twofa-confirm-btn {
  width: 100%;
  height: 52px;
  border: 0;
  border-radius: 16px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 800;
  background: var(--blue);
  box-shadow: 0 14px 28px rgba(18, 44, 106, 0.18);
  cursor: pointer;
}

.twofa-confirm-btn:hover,
.twofa-confirm-btn:focus {
  filter: brightness(0.94);
}

@media (max-width: 520px) {
  .twofa-auth-modal .modal-dialog {
    max-width: none;
    margin-left: 14px;
    margin-right: 14px;
  }

  .twofa-auth-card {
    padding: 30px 22px 28px;
  }

  .twofa-auth-heading h3 {
    font-size: 23px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/2FAModal.vue